<template>
    <div class="admin" ref="admin">
        <Headbar />
        <Sidebar :worknum="worknum_t" :meet_finish="meet_finish_t"></Sidebar>
        <Container >
            <router-view :rez_num="rez_num_t"/>
<!--            <keep-alive>-->
<!--                <router-view :rez_num="rez_num_t"/>-->
<!--            </keep-alive>-->

        </Container>

    </div>
</template>
<script>
    import Headbar from "@/components/Headbar.vue";
    import Sidebar from "@/components/Sidebar.vue";
    import Container from "@/components/Container.vue";
    import router from "@/router/router";
    import {isMobile} from "@/api/order";

    export default {
        name: "Admin",
        components: {
            Headbar,
            Sidebar,
            Container
        },
        provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
            return {
                work_list: this.workList,
                rez_create: this.rez_create,
                rez_status_change: this.rez_status_change,
                worknum: this.worknum_t,
                meet_finish: this.meet_finish_t,
                rez_num: this.rez_num_t,
                rez_status: this.rez_status_t,
                rev_notice: this.rev_notice_change,
                is_notice_change: this.rev_notice,
                voice_close: this.voice_close,
                voice_open: this.voice_open,
                voice_notice: this.voice_notice,
                chat_no_reply: this.chat_no_reply,
                apply_user_detail: this.apply_user_detail,
                health_record_log: this.health_record_log,
                chat_params: this.chat_params,
                apply_user_params: this.apply_user_params,
                health_record_params: this.health_record_params,
                user_apply: this.user_apply,
                user_apply_detail_params: this.user_apply_detail_params,
                user_apply_count_params: this.user_apply_count_params,
            }
        },
        data() {
            return {
                worknum_t: false, // 对应工作台变化
                meet_finish_t: false, // 对应会面完成变化
                rez_num_t: {
                    rez_val: false
                }, // 对应创建预约单变化
                rez_status_t: {
                    rez_val: false
                }, // 对应创建预约单变化
                rev_notice: {
                    is_notice: false
                }, // 对应创建预约单变化
                voice_notice: {
                    is_voice: false
                }, // 开启语音提醒
                chat_params: {
                    user_id: null,
                    obj_id: null,
                    friend_name: null,
                    user_name: null,
                    is_new: false,
                },
                user_apply_detail_params: {
                    user_name: null,
                    mobile: null,
                    is_new: false,
                },
                health_record_params: {
                    user_name: null,
                    doctor_name: null,
                    is_new: false,
                },
                user_apply_count_params: {
                    number:0,
                    is_change:false,
                },
            };
        },
        mounted() {
            if (process.env.NODE_ENV === 'production') {
                let url = window.location.href
                if (document.location.protocol == 'http:' && url.indexOf('192') < 0) {
                    url = url.replace('http:', 'https:')
                    window.location.href = url
                }
            }

            localStorage.setItem('is_refresh', 'false')
        },
        methods: {
            workList() {
                // 进入工作工作台变化
                this.worknum_t = !this.worknum_t
                this.meet_finish_t = !this.meet_finish_t
            },
            rez_create() {
                // 收到创建预约单变化
                this.rez_num_t.rez_val = !this.rez_num_t.rez_val
            },
            rez_status_change() {
                // 收到创建预约单变化
                this.rez_status_t.rez_val = !this.rez_status_t.rez_val
            },
            rev_notice_change() {
                // 收到创建预约单变化
                this.rev_notice.is_notice = !this.rev_notice.is_notice
            },
            voice_close() {
                // 关闭语音提醒
                this.voice_notice.is_voice = false
            },
            voice_open() {
                // 开启语音提醒
                this.voice_notice.is_voice = true
            },
            chat_no_reply(user_id, obj_id, friend_name, own_name) {
                process.env.NODE_ENV !== 'production' && console.log(user_id, obj_id, friend_name, own_name)
                this.chat_params.user_id = user_id;
                this.chat_params.obj_id = obj_id;
                this.chat_params.friend_name = friend_name;
                this.chat_params.own_name = own_name;
                this.chat_params.is_new = !this.chat_params.is_new
            },
            apply_user_detail(user_name, mobile) {
                process.env.NODE_ENV !== 'production' && console.log(user_name, mobile)
                this.user_apply_detail_params.user_name = user_name;
                this.user_apply_detail_params.mobile = mobile;
                this.user_apply_detail_params.is_new = !this.user_apply_detail_params.is_new
            },
            health_record_log(user_name, doctor_name) {
                process.env.NODE_ENV !== 'production' && console.log(user_name, doctor_name)
                this.health_record_params.user_name  = user_name;
                this.health_record_params.doctor_name = doctor_name;
                this.health_record_params.is_new = !this.health_record_params.is_new
            },
            user_apply(number) {
                this.user_apply_count_params.number = number*2
                this.user_apply_count_params.is_change = !this.user_apply_count_params.is_change
            }
        },
        watch: {
            res_number: {
                immediate: true,
                deep: true,
                handler(nVal) {
                    process.env.NODE_ENV !== 'production' && console.log(nVal)
                    if (this.is_watch) {

                    }


                },
            },
        },
    };
</script>
<style lang="scss" >
    .admin {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .el-message.is-closable {
        background-color: #fef0f0;
        border-color: #fde2e2;
        color: #F56C6C;
        .el-message__icon.el-icon-warning.el-message__icon_color{
            color: #F56C6C;
        }
    }
    .el-input.is-disabled .el-input__inner,.el-radio__input.is-disabled+span.el-radio__label{
        color: #606266;
    }
</style>


